<div class="p-6 max-w-5xl mx-auto">

  <div class="flex items-center gap-3 mb-6">
    <h1 class="text-lg font-semibold text-slate-800">Debug: Makers / Users</h1>
    <span class="text-xs px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 font-medium">internal</span>
  </div>

  <div class="flex items-center gap-2 mb-4">
    <span class="text-xs text-slate-500 font-medium">Source: SQLite (OPFS)</span>

    <button
      type="button"
      class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white rounded-lg shadow hover:bg-slate-50 border-0 cursor-pointer transition-colors"
      (click)="load()"
      [disabled]="this.loading()"
    >Refresh</button>

    @if (!this.loading()) {
      <span class="text-xs text-slate-400">
        {{ this.users().length }} user{{ this.users().length === 1 ? '' : 's' }}
      </span>
    }
    @if (this.loading()) {
      <span class="text-xs text-slate-400">Loading&hellip;</span>
    }
  </div>

  <!-- Error -->
  @if (this.error()) {
    <div class="mb-4 px-4 py-3 rounded-lg bg-red-50 border border-red-200 text-xs text-red-700">
      {{ this.error() }}
    </div>
  }

  <!-- Table -->
  @if (!this.loading() && !this.error()) {
    <div class="rounded-lg border border-slate-200 overflow-hidden">
      <table class="w-full text-xs">
        <thead class="bg-slate-50 text-slate-500 font-medium">
          <tr>
            <th class="px-4 py-2.5 text-left">Key</th>
            <th class="px-4 py-2.5 text-left">Display Name</th>
            <th class="px-4 py-2.5 text-left">Primary Email</th>
            <th class="px-4 py-2.5 text-left">All Emails</th>
          </tr>
        </thead>
        <tbody>
          @for (user of this.users(); track user) {
            <tr class="border-t border-slate-100 hover:bg-slate-50">
              <td class="px-4 py-2 font-mono text-slate-400">{{ user.key }}</td>
              <td class="px-4 py-2 text-slate-700">{{ user.displayName }}</td>
              <td class="px-4 py-2 text-slate-500">{{ user.email }}</td>
              <td class="px-4 py-2">
                @for (e of user.emails; track e) {
                  <span class="inline-block mr-1 mb-0.5 px-1.5 py-0.5 rounded bg-slate-100 text-slate-500 text-xs font-mono">{{ e }}</span>
                }
              </td>
            </tr>
          }
          @if (this.users().length === 0) {
            <tr class="border-t border-slate-100">
              <td colspan="4" class="px-4 py-6 text-center text-slate-400">No users found in SQLite.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

</div>
